import { MDENTURE_PRODUCTION_CENTER_ID } from '@/config/mdenture';
import type { OrderFlowState } from '@/services/api/types';

export function normalizeOrderState(state: string): string {
  return state
    .trim()
    .toLocaleLowerCase('de')
    .replace(/[_\s-]+/g, '');
}

function orderTypeKeyOf(orderType: string | number): string {
  if (typeof orderType === 'number') {
    return orderType === 0 ? 'production' : orderType === 1 ? 'designproduction' : String(orderType);
  }

  return normalizeOrderState(orderType);
}

function groupIdKeyOf(groupId: string | null | undefined): string {
  return groupId?.trim().toLocaleLowerCase('en-US') ?? '';
}

export function flowStatesForOrder(states: readonly OrderFlowState[], orderType: string): OrderFlowState[] {
  const orderTypeKey = orderTypeKeyOf(orderType);
  const typedStates = states.filter((state) => orderTypeKeyOf(state.orderType) === orderTypeKey);
  const groupStates = typedStates.filter(
    (state) => groupIdKeyOf(state.groupID) === groupIdKeyOf(MDENTURE_PRODUCTION_CENTER_ID),
  );

  return groupStates.length > 0
    ? groupStates
    : typedStates.filter((state) => groupIdKeyOf(state.groupID) === '');
}

export function isDesignReviewState(state: string): boolean {
  const normalizedState = normalizeOrderState(state);

  return (
    normalizedState === 'customerdesignreview' ||
    normalizedState === 'designreview' ||
    normalizedState === 'designfreigabe'
  );
}

export function isScanRevisionReviewFilesState(state: string): boolean {
  const normalizedState = normalizeOrderState(state);

  return normalizedState === 'scanrevision' || normalizedState === 'scanrevisionreviewfiles';
}

export function isScanRevisionNewUploadState(state: string): boolean {
  const normalizedState = normalizeOrderState(state);

  return normalizedState === 'scanrevision' || normalizedState === 'scanrevisionnewupload';
}

export function isScanRevisionUploadOnlyState(state: string): boolean {
  return normalizeOrderState(state) === 'scanrevisionnewupload';
}

export function isScanRevisionState(state: string): boolean {
  return isScanRevisionReviewFilesState(state) || isScanRevisionNewUploadState(state);
}
